import { Box, Divider, Flex, HStack, Text } from '@chakra-ui/react';

type LegendProps = {
  labels: string[];
};

// Red, Blue, Green, Yellow, Orange
export const chartColors: string[] = ['#C00000', '#4BA5F1', '#81CCA4', '#EAB308', '#ED7D31'];

export function Legend({ labels }: LegendProps) {
  return (
    <Flex fontFamily="Montserrat">
      {labels.map((label, i) => {
        return (
          <Box mx="4" my="4">
            <HStack>
              <Divider
                orientation="horizontal"
                width="12"
                borderColor={`${chartColors[i]}`}
                borderWidth="medium"
              />
              <Text>{label}</Text>
            </HStack>
          </Box>
        );
      })}
    </Flex>
  );
}

export default Legend;
